import Avatar from "@material-ui/core/Avatar/Avatar";
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import NotInterestedOutlined from "@material-ui/icons/NotInterestedOutlined";

import React from "react";

const tabConfig = [
  {
    columnTitle: "Título",
    dataField: ["title"],
  },

  {
    columnTitle: "Descripción",
    dataField: ["description"],
  },

  {
    columnTitle: "Fecha",
    dataField: ["createdAt"],
  },
];

export default tabConfig;
